import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { CovanceGridColumn } from '../../../covance-ag-grid';
import { ActivatedRoute } from '@angular/router';
import { routeData } from '../../../shared/route-helpers';
import { map } from 'rxjs/operators';
import { Site } from '../../../sites';
import { EQUERIES_STORAGE } from '../../../e-queries/external-user-e-queries-storage';
import { InvestigatorEQueriesStorage } from '../investigator-e-queries-storage';
import {EQueryTab} from '../../../e-queries/models/e-query-tab.enum';
import {FilterFieldValue} from '../../../covance-filter';

@Component({
    selector: 'investigator-e-query-grid',
    template: require('./investigator-e-query-grid.component.html'),
    styles: [require('./investigator-e-query-grid.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: EQUERIES_STORAGE, useExisting: InvestigatorEQueriesStorage }
    ],
})
export class InvestigatorEQueryGridComponent {
    @Input()
    public showReadByMe = true;
    @Input()
    public columns: CovanceGridColumn[];
    @Input()
    public eQueryTab: EQueryTab;
    @Input()
    public filterDefs: FilterFieldValue[];
    @Input()
    public siteId$: Observable<number>;
    constructor(route: ActivatedRoute) {
        const selectedSite = route.parent.parent.data.pipe(map(d => d[routeData.selectedSite] as Site));
        this.siteId$ = selectedSite.pipe(map(s => s.siteId));
    }
}
